import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: ", "px;\n  box-sizing: border-box;\n  color: ", ";\n  cursor: ", ";\n  display: block;\n  font-size: ", "px;\n  font-weight: ", ";\n  height: ", ";\n  outline: 1px solid ", ";\n  outline-offset: -2px;\n  padding: 0 ", "px;\n  transition: border-color ", ", outline-color ", ";\n  width: 100%;\n\n  &:focus {\n    border-color: ", ";\n    outline-color: ", ";\n  }\n\n  /* IE doesnt't support outlife-offset, therefore disable the animation */\n  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    box-shadow: inset 0 0 0 1px ", ";\n    outline: none;\n    transition: none;\n\n    &:focus {\n      box-shadow: inset 0 0 0 1px ", ";\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { color, property, typography } from '@scp/ui-shared/theme/variables';
import { FIELD_FONT_SIZE, FIELD_INNER_PADDING, FIELD_HEIGHT } from '@scp/ui-shared/components/form-fields/constants';

var getBorderColor = function getBorderColor(_ref) {
  var disabled = _ref.disabled,
      isInvalid = _ref.isInvalid,
      isFocused = _ref.isFocused;
  if (disabled) return color.border;
  if (isInvalid) return color.invalid;
  if (isFocused) return color.action;
  return color.borderInput;
};

var getOutlineColor = function getOutlineColor(_ref2) {
  var disabled = _ref2.disabled,
      isInvalid = _ref2.isInvalid,
      isFocused = _ref2.isFocused;
  if (disabled) return 'transparent';
  if (isInvalid) return color.invalid;
  if (isFocused) return color.action;
  return 'transparent';
};

var getCursorType = function getCursorType(_ref3) {
  var disabled = _ref3.disabled,
      cursorType = _ref3.cursorType;
  if (disabled) return 'not-allowed';
  if (cursorType) return cursorType;
  return 'pointer';
};

export var FieldBase = styled.div(_templateObject(), color.palette.white, getBorderColor, property.borderRadius, function (props) {
  return props.disabled ? color.textSecondary : color.textPrimary;
}, getCursorType, FIELD_FONT_SIZE, typography.fontWeightNormal, FIELD_HEIGHT, getOutlineColor, FIELD_INNER_PADDING, property.transition, property.transition, function (props) {
  return getBorderColor(Object.assign(Object.assign({}, props), {
    isFocused: true
  }));
}, function (props) {
  return getOutlineColor(Object.assign(Object.assign({}, props), {
    isFocused: true
  }));
}, getOutlineColor, function (props) {
  return getOutlineColor(Object.assign(Object.assign({}, props), {
    isFocused: true
  }));
});